import { Component, Input, SimpleChanges } from '@angular/core';
import { BatteryTypeOption, toBatteryTypeSeries } from 'src/app/_shared/utils/battery-type';
import { TransformXAxisPipe } from 'src/app/_shared/pipes/transform-xaxis.pipe';
import { createPlotlyChart } from 'src/app/_shared/plotlyConfig';

@Component({
  selector: 'app-soc-start-chart',
  templateUrl: './soc-start-chart.component.html',
  styleUrls: ['./soc-start-chart.component.scss']
})
export class SocStartChartComponent {
  @Input() fleetId: string[] = [];
  @Input() selectedBatteryTypes: BatteryTypeOption[] = [];
  @Input() dataLoadingSoc!: boolean;
  @Input() errorMessageSoc!: boolean;
  @Input() stateOfChargeDatapoints!: any;
  chartRange!: { range: [number, number]; };
  
  ngOnChanges(changes: SimpleChanges): void {
    if (Object.keys(this.stateOfChargeDatapoints).length !== 0) {
      this.plotSocStartChart();
    }
    
  }
  
  plotSocStartChart() {
    const transformXAxisPipe = new TransformXAxisPipe();

    const data = toBatteryTypeSeries(this.stateOfChargeDatapoints, this.selectedBatteryTypes).map((series) => {
      const filteredData = series.datapoints.filter((dataObject: any) => dataObject.chargingSessionsInit !== null);
      return {
        x: filteredData.map((dataObject: any) => dataObject.binSoc),
        y: filteredData.map((dataObject: any) => dataObject.chargingSessionsInit),
        type: 'bar',
        name: series.label,
        marker: {
          color: series.color
        }
      };
    });

    const initialSoc = data.flatMap((trace) => trace.x);
    const percentAmount = data.flatMap((trace) => trace.y);

    if (percentAmount.length === 0) {
      this.errorMessageSoc = true;
      return;
    } else {
      this.errorMessageSoc = false;
    }

    this.chartRange = transformXAxisPipe.transform(initialSoc, percentAmount, 5, 100);

    const layout = {
      title: 'Initial State of Charge',
      font: {
        family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
        size: 13,
      },
      barmode: 'group',
      xaxis: {
        title: 'Initial State of Charge [%]',
        range: this.chartRange?.range
      },
      yaxis: {
        title: 'Percentage of Charging Sessions [%]'
      },
      showlegend: true,
      legend: {
        orientation: 'h', 
        y: -0.3, 
        xanchor: 'center', 
        x: 0.5,
        font: {
          family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
          size: 13,
        },
      }
    };
    createPlotlyChart('soc-start-chart', data, layout);
  }
}